var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"ytplayer","type":"text/html","width":"100%","height":"96%","src":"https://www.youtube.com/embed/wk6Qr6OO5Xo","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }